import React from 'react';
import { rootStore, storeContext } from './mobx';

interface StoreProviderProps {
    children: React.ReactNode;
}

export const StoreProvider = ({ children }: StoreProviderProps) => {
    return (
        <storeContext.Provider value={rootStore}>
            {children}
        </storeContext.Provider>
    );
};
